import { render, staticRenderFns } from "./WelfareShelter.vue?vue&type=template&id=477e90b5"
import script from "./WelfareShelter.vue?vue&type=script&lang=js"
export * from "./WelfareShelter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports